import React, { useState } from 'react';
import Navbar from '../layout/Navbar';
import { decryptData } from '../../utils/encrypt';
import { ORG_SEARCH_ENDPOINT } from '../../config/api';

function OrganizationSearch() {
  const [keyword, setKeyword] = useState('');
  const [results, setResults] = useState([]);
  const [message, setMessage] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    setMessage('');
    setResults([]);

    if (!keyword.trim()) {
      setMessage('Please enter a search keyword');
      return;
    }

    // ✅ Decrypt user_token
    const encrypted = localStorage.getItem('suyog_user');
    let user_token = '';

    try {
      if (encrypted) {
        const user = decryptData(encrypted);
        user_token = user.user_token || '';
      }
    } catch {
      setMessage('Invalid user session');
      return;
    }

    // ✅ Make API call
    try {
      const url = `${ORG_SEARCH_ENDPOINT}?keyword=${encodeURIComponent(keyword)}&user_token=${encodeURIComponent(user_token)}`;
      const res = await fetch(url);
      const data = await res.json();

      if (res.ok && Array.isArray(data)) {
        if (data.length === 0) {
          setMessage('No organizations found');
        } else {
          setResults(data);
        }
      } else {
        setMessage(data.error || 'Search failed');
      }
    } catch {
      setMessage('Server error');
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
       <div className="d-flex justify-content-between align-items-center mb-3">
  <h4 className="mb-0">Search Organization</h4>
  <a href="/organization/add" className="btn btn-success">
    + Add New
  </a>
</div>

        <form className="mb-3" onSubmit={handleSearch}>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Search by name, city, etc."
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
            <button className="btn btn-primary" type="submit">Search</button>
          </div>
        </form>

        {message && <div className="alert alert-info">{message}</div>}

        {results.length > 0 && (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>City</th>
                  <th>GST</th>
                  <th>PAN</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {results.map((org, index) => (
                  <tr key={org.id}>
                    <td>{index + 1}</td>
                    <td>{org.org_name}</td>
                    <td>{org.city}</td>
                    <td>{org.gst_number}</td>
                    <td>{org.pan_number}</td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
}

export default OrganizationSearch;
